import { useTranslation } from 'react-i18next';

import { Badge } from '../../components/Badge';
import { ErrorNotice } from '../../components/ErrorNotice';
import { SkeletonTable } from '../../components/Skeleton';
import { usePersonalDataRegister } from './queries';

const TONE: Record<string, 'neutral' | 'info' | 'success' | 'warning' | 'danger'> = {
  replace: 'success',
  clear: 'success',
  keep: 'neutral',
  free_text: 'warning',
};

/**
 * Das Verzeichnis der personenbezogenen Felder -- F5-15, K-154.
 *
 * **Es kommt vom Server und wird hier nicht gefuehrt.** Eine zweite Liste in
 * der Oberflaeche liefe auseinander, sobald ein Feld dazukommt -- und ein
 * Verzeichnis, das ein Feld auslaesst, ist in einer Pruefung schlimmer als
 * keines: Es behauptet Vollstaendigkeit.
 *
 * ``free_text`` ist gelb, weil es die einzige Zeile ist, bei der jemand
 * nachsehen muss: Dort kann ein Personenbezug im Fliesstext stehen, den keine
 * Automatik findet (F5-12).
 */
export function RegisterPanel() {
  const { t } = useTranslation();
  const register = usePersonalDataRegister();

  return (
    <div className="stack">
      <section className="card">
        <p className="table__muted">{t('privacy.registerHint')}</p>
      </section>

      {register.isPending ? <SkeletonTable columns={3} /> : null}
      {register.isError ? <ErrorNotice error={register.error} /> : null}

      {(register.data ?? []).map((table) => (
        <section className="card card--flush" key={table.table}>
          <div className="card__header">
            <h2>{table.label}</h2>
            <p className="table__muted">{table.link}</p>
          </div>
          <div className="table-wrapper">
            <table className="table">
              <thead>
                <tr>
                  <th scope="col">{t('privacy.field')}</th>
                  <th scope="col">{t('privacy.fieldDescription')}</th>
                  <th scope="col">{t('privacy.treatment')}</th>
                </tr>
              </thead>
              <tbody>
                {table.fields.map((field) => (
                  <tr key={field.name}>
                    <td>
                      <code>{field.name}</code>
                    </td>
                    <td className="table__muted">{field.description}</td>
                    <td>
                      <Badge tone={TONE[field.treatment] ?? 'neutral'}>
                        {t(`fieldTreatment.${field.treatment}`, { defaultValue: field.treatment })}
                      </Badge>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </section>
      ))}
    </div>
  );
}
